/* eslint-disable */

// Vendor
import Vendor from "@/views/Vendor.vue";
import vendorIndex from "@/components/vendor/Index.vue";
import vendorForm from "@/components/vendor/Form.vue";

//Middleware
import isLogin from "@/middleware/AuthMiddleware.js";

export default 
{
  path: "/vendor",
  component: Vendor,
  children:[
    {
      path:'/',
      name: "vendor",
      component:vendorIndex,
      meta:{
        parent: "vendor",
        title: "Vendor",
        navbar:true,
        middleware:[
          isLogin,
        ]
      },
    },
    {
      path:'add',
      component:vendorForm,
      name: 'vendor.add',
      meta:{
        parent: "vendor",
        title: "Tambah Vendor",
        navbar:true,
        middleware:[
          isLogin,
        ]
      }
    },
    {
      path:'edit/:id',
      component:vendorForm,
      name:"vendor.edit",
      meta:{
        parent:"vendor",
        navbar:true,
        middleware:[
          isLogin,
        ]
      }
    }
  ]
}